import '@/styles/common/Mypage/textbox.scss';

import React from 'react';

import { TitleSectionTitle } from '@/components/common/Title/SectionTitle';
import { ButtonTextLink } from '@/components/common/Button/TextLink';
import { MatchboxUserResponse } from '@/utils/api-client';

type Props = {
  user: MatchboxUserResponse | undefined;
};

export const SectionSelfResume = (props: Props): React.ReactElement => {
  return (
    <section className="mt-48">
      <TitleSectionTitle>
        <div className="flex items-center">
          <span className="mr-4">自作の履歴書・職務経歴書の登録</span>
        </div>
      </TitleSectionTitle>
      <p className="text-14_21">
        自作の履歴書・職務経歴書があれば、登録（アップロード）してマイナビワークスのキャリアアドバイザーに見せることができ、企業へのアピールにつながります。
        <br />
        設定の変更は、
        <ButtonTextLink href="/mypage/self-resume-cv/edit">こちらから</ButtonTextLink>
        行うことができます。
      </p>
      <div>
        <div className="flex flex-row pt-24 pb-6 items-center">
          <p className="text-12_16 font-bold">現在の設定</p>
        </div>
        <div className="mkt_mask_items">
          {!props?.user?.resume && !props?.user?.career_history ? (
            <p className="mbx-textbox-color mbx-textbox">未登録</p>
          ) : (
            <div className="mbx-textbox-color mbx-textbox">
              <div className="flex">
                <p className="w-88 flex-none">履歴書 :</p>
                <div className="min-w-0">
                  {props?.user.resume ? (
                    <div className="lg:flex items-center">
                      <p className="mr-16 flex-none">{props?.user.resume.date}</p>
                      <div className="flex items-center min-w-0">
                        <p className="truncate">{props?.user.resume.name}</p>
                        <p className="flex-none">({props?.user.resume.size})</p>
                      </div>
                    </div>
                  ) : (
                    <>未登録</>
                  )}
                </div>
              </div>
              <div className="flex mt-8">
                <p className="w-88 flex-none">職務経歴書 :</p>
                <div className="min-w-0">
                  {props?.user.career_history ? (
                    <div className="lg:flex items-center">
                      <p className="mr-16 flex-none">{props?.user.career_history.date}</p>
                      <div className="flex items-center min-w-0">
                        <p className="truncate">{props?.user.career_history.name}</p>
                        <p className="flex-none">({props?.user.career_history.size})</p>
                      </div>
                    </div>
                  ) : (
                    <>未登録</>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
